import type { IconSvgObject } from './types';

const ArrowUpToLineIcon: IconSvgObject = [
  ["path", { d: "M12 8L12 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 3L6 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 12C17 12 13.3176 7.00001 12 7C10.6824 6.99999 7 12 7 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowUpToLineIcon;
